<template>
  <div class="pay" v-if="show">
    <div class="pay-cell" v-if="titleInfo.show" @click="addBank">
      <div class="pay-cell__title">{{ titleInfo.title }}</div>
      <div class="pay-cell__button" v-if="list.length">
        <span>{{ titleInfo.text }}</span>
        <span class="pay-cell__icon"></span>
      </div>
    </div>
    <div class="pay-list" v-if="list.length">
      <div class="pay__item" v-for="(item, index) in list" :key="item.bankId" @click="check(index)">
        <div class="pay-header">
          <img class="pay-logo" :src="item.icon" />
        </div>
        <div class="pay-info">
          <div class="pay-info__title">{{ item.bankName }}</div>
          <!--<view class="pay-info__text">快的飞起</view>-->
        </div>
        <SvgIcon v-if="item.isSelect" name="icon-fuxuan" size="0.64rem" :color="theme.PerformanceSelectIconColor" />
        <img
          v-else
          style="width:24px;height:24px;"
          slot="icon"
          src="https://x.jzbull.com/x_dsx_wxapp/icov_newPart/xuan0.png"
        />
      </div>
    </div>
    <div class="pay-list" v-else>
      <div class="pay__item" @click="addBank">
        <div class="pay-empty-header">
          <img class="pay-empty-logo" src="https://x.jzbull.com/x_dsx_wxapp/market/bank/empty-bank.png" />
        </div>
        <div class="pay-empty-info">
          <div class="pay-info__title">添加银行卡</div>
          <div class="pay-info__text">增加快捷支付银行卡</div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import SvgIcon from '@/components/SvgIcon.vue'
import {useUserStore} from '@/store/user'
export default {
  components: {
    SvgIcon
  },
  props: {
    show: {
      type: Boolean,
      value: true
    },
    titleInfo: {
      type: Object,
      value: {
        show: false
      }
    },
    // theme: {
    //   type: Object,
    //   value: {}
    // },
    list: {
      type: Array,
      value: []
    }
  },
  emits: ['check', 'addBank'],
  setup(props, { emit }) {
    const userStore = useUserStore()
    const theme = computed(() => userStore.getTheme)
    onMounted(async () => {
    })
    function check(index) {
      emit('check', index)
    }
    function addBank() {
      emit('addBank')
    }
    return {
      check,
      addBank,
      theme
    }
  }
}
</script>
<style lang="less" src="./pay.less"></style>
